/**
 * Методы и Api юзера
 *
 */
window.UK = (() => {
        "use strict";

        const API = {
                async setUserRegion(value = null) {
                        if (value == null || isNaN(Number(value))) {
                                return { success: false, error: "Введено некорректное значение!" };
                        }

                        const url = '/ajax/api/cabinet?region=' + value;

                        try {
                                const response = await fetch(url, {
                                        method: "POST",
                                        headers: {
                                                "Content-Type": "application/json",
                                                "X-Requested-With": "XMLHttpRequest",
                                        },
                                        //body: JSON.stringify({ ...payload }),
                                });

                                const result = await response.json();

                                if (!result.success) {
                                        return { success: false, error: result.message || "Ошибка смены региона" };
                                }

                                return { success: true, data: result.data || {}, message: result.message };
                        } catch (e) {
                                return { success: false, error: e.message || "Ошибка сети" };
                        }

                },

                async changeEmail(payload = {}) {
                        const {
                                new_email = "",
                                phone = "",
                                code = "",
                                sign = ""
                        } = payload;

                        if (!new_email) {
                                return {
                                        success: false,
                                        error: "Не указана новая почта."
                                };
                        }
                        // остальные параметры определяются от isMobileRegistered

                        const url = '/ajax/api/zayav_change_email';
                        // true — JSON, false — application/x-www-form-urlencoded
                        const useJson = false;

                        try {
                                const headers = {
                                        "X-Requested-With": "XMLHttpRequest"
                                };

                                let body;

                                if (useJson) {
                                        headers["Content-Type"] = "application/json";

                                        body = JSON.stringify({
                                                new_email,
                                                phone,
                                                code,
                                                sign
                                        });
                                } else {
                                        headers["Content-Type"] = "application/x-www-form-urlencoded";

                                        body = new URLSearchParams({
                                                new_email,
                                                phone,
                                                code,
                                                sign
                                        });
                                }

                                const response = await fetch(url, {
                                        method: "POST",
                                        headers,
                                        body
                                });

                                const result = await response.json();

                                if (!result.success) {
                                        return {
                                                success: false,
                                                error: result.message || "Ошибка при отправке заявления"
                                        };
                                }

                                return {
                                        success: true,
                                        data: result.data || {},
                                        message: result.message
                                };
                        } catch (e) {
                                return {
                                        success: false,
                                        error: e.message || "Ошибка сети"
                                };
                        }
                },

                /**
                 * Отправка кода подтверждения на контакт (телефон или email)
                 * @param {string} type - 'phone', 'email' или 'new_email'
                 * @param {string} contactValue - значение контакта
                 */
                async sendVerificationCode(type, contactValue) {
                        if (!type || !contactValue) {
                                return { success: false, error: "Не указан тип или значение контакта" };
                        }

                        const url = `/ajax/api/confirmContact?${type}=${encodeURIComponent(contactValue)}&action=send`;
                        try {
                                const response = await fetch(url, {
                                        method: "POST",
                                        headers: { "X-Requested-With": "XMLHttpRequest" }
                                });
                                const result = await response.json();
                                return result.success
                                        ? { success: true, data: result.data || {}, message: result.message }
                                        : { success: false, error: result.message || "Ошибка отправки кода" };
                        } catch (e) {
                                return { success: false, error: e.message || "Ошибка сети" };
                        }
                },

                /**
                * Проверка введенного кода подтверждения
                * @param {string} type - 'phone', 'email' или 'new_email'
                * @param {string} contactValue - значение контакта
                * @param {string} code - введенный код
                */
                async checkVerificationCode(type, contactValue, code) {
                        if (!type || !contactValue || !code) {
                                return { success: false, error: "Не указаны все параметры для проверки кода" };
                        }
                        const url = `/ajax/api/confirmContact?${type}=${encodeURIComponent(contactValue)}&action=check&code=${encodeURIComponent(code)}`;
                        try {
                                const response = await fetch(url, {
                                        method: "POST",
                                        headers: { "X-Requested-With": "XMLHttpRequest" }
                                });
                                const result = await response.json();
                                return result.success
                                        ? { success: true, data: result.data || {}, message: result.message }
                                        : { success: false, error: result.message || "Неверный код" };
                        } catch (e) {
                                return { success: false, error: e.message || "Ошибка сети" };
                        }
                },


        }



        async function _handleRequest(request) {
                const res = await request;

                if (res.success === false) {
                        aAlert(res.error);
                        return;
                }

                return res;
        }

        const actions = {
                async changeRegion(value = null) {
                        return _handleRequest(API.setUserRegion(value));
                },

                async changeEmail(payload = {}) {
                        return _handleRequest(API.changeEmail(payload));
                }
        }

        return {
                ...actions,

                // низкоуровневые api, используемые в другом месте
                api: {
                        sendVerificationCode: API.sendVerificationCode,
                        checkVerificationCode: API.checkVerificationCode
                }
        }
})();
